import {
  PROFILE_DATA_PRIVACY_PATH,
  PROFILE_EMAIL_UPDATE_PATH,
  PROFILE_ORGANIZATIONS_PATH,
  PROFILE_PASSWORD_UPDATE_PATH,
  PROFILE_PATH,
  PROFILE_SECURITY_PATH
} from 'configs';

export type ProfileNavItem = {
  key: string;
  to: string;
  label: string;
};

type TranslationFn = (key: string) => string;

type UserProfileWithBilling = {
  billingAddress?: {
    addressType?: string | null;
  };
};

export const getProfileNavItems = (
  t: TranslationFn,
  currentUserProfile?: UserProfileWithBilling
): ProfileNavItem[] => {
  const isBusinessAccount =
    currentUserProfile?.billingAddress?.addressType === 'business';

  return [
    {
      key: PROFILE_PATH,
      to: PROFILE_PATH,
      label: t('pages.yourProfile')
    },
    ...(isBusinessAccount
      ? [
          {
            key: PROFILE_ORGANIZATIONS_PATH,
            to: PROFILE_ORGANIZATIONS_PATH,
            label: t('pages.organization')
          }
        ]
      : []),
    {
      key: PROFILE_EMAIL_UPDATE_PATH,
      to: PROFILE_EMAIL_UPDATE_PATH,
      label: t('pages.changeEmail')
    },
    {
      key: PROFILE_PASSWORD_UPDATE_PATH,
      to: PROFILE_PASSWORD_UPDATE_PATH,
      label: t('pages.changePassword')
    },
    {
      key: PROFILE_SECURITY_PATH,
      to: PROFILE_SECURITY_PATH,
      label: t('pages.security')
    },
    {
      key: PROFILE_DATA_PRIVACY_PATH,
      to: PROFILE_DATA_PRIVACY_PATH,
      label: t('pages.dataPrivacy')
    }
  ];
};

